export function normalizeGames(games) {
  const gamesToNormalize = Array.isArray(games) ? games : [];

  return gamesToNormalize
    .map((game) => {
      const tag = game.tag_bn || game.tag_en;
      let gameTag = "";
      if (typeof tag === "string") {
        gameTag = tag.trim();
      } else if (tag && typeof tag === "object") {
        gameTag = tag.bn || tag.en || "";
      }

      return {
        ...game,
        game_id: String(game.game_id !== undefined ? game.game_id : game.id),
        game_name: game.name_bn || game.game_name || game.name_en || game.title_bn || game.title_en,
        game_image_url: game.thumbnail_url,
        game_desktop_image_url: game.desktop_image_url,
        game_mobile_image_url: game.mobile_image_url,
        game_slug: game.game_slug || game.key || String(game.id),
        tournament_image_url: game.banner_url,
        tournament_mobile_image_url: game.mobile_banner_url || game.banner_url,
        game_tag: gameTag,
      };
    })
    .sort((a, b) => a.display_order - b.display_order);
}
